import hrms74eLabels from 'assets/labels/hrms74e'
import moment from 'moment'
import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms74eLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        codempid: faker.random.word(),
        desc_codempid: faker.name.findName(),
        desc_codpos: faker.name.jobType(),
        staappr: '',
        desc_staappr: mockStatus[staappr],
        codcours: faker.random.word(),
        desc_codcours: faker.random.words(),
        desc_codtparg: 'ภายใน',
        v_flgqlify: 'ใช่',
        dteappr: moment().format('DD/MM/YYYY'),
        codappr: faker.random.word(),
        desc_codappr: faker.name.findName(),
        v_flg: '',
        dteyear: moment().format('YYYY'),
        codcomp: faker.random.word(),
        codpos: faker.random.word(),
        codplan: 'D',
        numlvl: '70',
        nummemo: '001/2558',
        flgqlify: 'Y',
        v_flgtrn: 'S',
        codtparg: faker.random.number().toString().substr(0, 1),
        dtetrst: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        dtemonth: Math.floor(Math.random() * 11) + 1,
        numclseq: faker.random.number().toString().substr(0, 1)
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  indexAddInline (param) {
    return {
      codempid: param.codempid,
      desc_codempid: faker.name.findName(),
      desc_codpos: faker.name.jobType(),
      desc_staappr: '',
      codcours: faker.random.word(),
      desc_codcours: faker.random.words(),
      desc_codtparg: 'ภายใน',
      v_flgqlify: 'ใช่',
      dteappr: moment().format('DD/MM/YYYY'),
      desc_codappr: faker.name.findName(),
      dteyear: moment().format('YYYY'),
      v_dtemonth: moment().format('MMMM'),
      numclseq: faker.random.number().toString().substr(0, 1)
    }
  },
  detail () {
    let mockTab1 = {
      conbsc: 'N',
      conspc: 'Y',
      concours: 'Y',
      flgretrn: 'Y',
      flgretrn2: 'Y',
      dtelsttr: '01/07/2017',
      v_plncond: '( รหัสพนักงาน >= "33018" AND ประเภทการจ่ายเงินเดือน = รายเดือน ) AND หลักสูตรที่ควรเข้าอบรมจากการประเมินผล ( ปีที่ประเมิน 2015 ครั้งที่ 1 )  OR ระดับการศึกษา = ประกาศนียบัตรวิชาชีพ (ปวท.) AND เฉพาะคนที่เคยอบรม ( วันที่อบรมล่าสุด 01/07/2560 )  AND เฉพาะคนที่เคยอบรมและคะแนนไม่ผ่าน',
      v_logical: 'ระดับการศึกษา = ประกาศนียบัตรวิชาชีพ (ปวท.)',
      v_syncond: 'รหัสพนักงาน >= "33018" AND ประเภทการจ่ายเงินเดือน = รายเดือน'
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        codcours: faker.random.word(),
        desc_codcours: faker.random.words(),
        dteyear: moment().format('YYYY'),
        dtemonth: moment().format('MMMM'),
        numclseq: faker.random.number().toString().substr(0, 1),
        desc_tparg: 'ภายใน',
        amttrexp: faker.commerce.price(),
        qtytotscr: faker.random.number().toString().substr(0, 2),
        desc_flgtrevl: 'ผ่าน'
      })
    }
    let mockTab3Rows = []
    const mockTab3Total = 5
    for (var a = 1; a <= mockTab3Total; a++) {
      mockTab3Rows.push({
        codcours: faker.random.word(),
        desc_codcours: faker.random.words(),
        desc_dtemonth: moment().format('MMMM'),
        numclseq: faker.random.number().toString().substr(0, 1),
        dtetrst: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        desc: faker.name.findName(),
        desc_codhotel: faker.address.streetAddress()
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        total: mockTab2Total,
        rows: mockTab2Rows
      },
      tab3: {
        total: mockTab3Total,
        rows: mockTab3Rows
      }
    }
  },
  approve () {
    return {
      dteyear: '',
      codcours: '',
      codempid: '',
      codappr: '',
      dteappr: '',
      staappr: '',
      remarkap: '',
      dtemonth: '',
      numclseq: '',
      codplan: '',
      codtparg: '',
      dtetrst: '',
      dtetren: '',
      flgqlify: ''
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms74e/mocker.js